<template>
  <v-dialog persistent v-model="dialog" width="500">
    <v-card>
      <ModelTitle title="Extra Cost" @close="close" />
      <v-container grid-list-md>
        <v-layout row align-center>
          <v-flex xs8>
            <ProductAutoComplete :rounded="false" @submit="productSelected" :nonSerialized="true"/>
          </v-flex>
          <v-flex xs4>
            <v-text-field
            outlined dense hide-details label="Price" v-model="price"
          ></v-text-field>
          </v-flex>
        </v-layout>
        <v-divider class="my-2"></v-divider>
        <v-layout row align-center>
          <v-flex>
            <v-text-field outlined label="Serial Number" v-model="serialNumber" @keyup.enter="enterSerial"
              ref="enterSerial" @focus="$event.target.select()" :disabled="loading" dense
              :loading="loading"></v-text-field>
          </v-flex>
          <v-flex shrink align-self-start="">
            <v-btn :disabled="!serialNumber" :loading="loading" large color="info"
              @click="enterSerial"> add </v-btn>
          </v-flex>
        </v-layout>
        <v-list class="list-350">
          <template v-for="(row, index) in serialList">
            <v-list-item :key="index">
              <v-list-item-avatar>
                <v-btn icon>
                  <v-icon color="red" @click="deleteNumber(index)">delete</v-icon>
                </v-btn>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title v-if="row">
                  <span>{{ row }}</span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
      </v-container>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="error" v-if="serialList.length" @click="clearAll">Clear All</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" :loading="extraCostDialogLoading" large :disabled="!serialList.length || !selectedProduct || !price" text
          @click="updateSerialCost">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import serialService from "@/modules/Inventory/Serial/service.js";
import extraSerializedCostService from "@/modules/Inventory/Serial/ExtraSerializedCost/service.js";
import ProductAutoComplete from "@/modules/Product/components/AutoComplete.vue";

export default {
  name: 'change-status',
  props: ['extraCostDialog'],
  data() {
    return {
      serialNumber: null,
      price: null,
      extraCostDialogLoading: false,
      selectedProduct: null,
      dialog: false,
      serialList: [],
      loading: false,
    }
  },
  watch: {
    extraCostDialog(val) {
      this.dialog = val
    },
  },
  components: {
    ProductAutoComplete,
  },
  methods: {
    productSelected(val){
        this.selectedProduct = val
        if(val)
          this.price = val.price
    },
    enterSerial() {
      this.loading = true
      if (this.serialList.length) {
        let index = this.serialList.indexOf(this.serialNumber);
        if (index != -1) {
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 4000,
            })
            .fire({
              icon: "error",
              title: `${this.serialNumber} is already in this list`,
            });
          this.loading = false

          return true
        }
      }
      return serialService.getAll({ imeiNumber: this.serialNumber, status: 'available' }).then((response) => {
        this.loading = false
        if (!response.data.length) {
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 4000,
            })
            .fire({
              icon: "error",
              title: `${this.serialNumber} not found`,
            });
          return true
        }
        this.serialList.push(this.serialNumber)
        this.serialNumber = null
        this.$nextTick(() => {
          this.$refs.enterSerial.focus();
        });
        return response;
      });
    },
    deleteNumber(index) {
      this.serialList.splice(index, 1)
    },
    clearAll() {
      this.serialList = []
    },
    updateSerialCost() {
      let obj = {
        serialList: this.serialList,
        price: this.price,
        ProductId: this.selectedProduct.id,
      }
      this.extraCostDialogLoading = true
      return extraSerializedCostService
        .updateAllBySerialNumber(obj)
        .then(result => {
          if (result.status) {
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: true,
                timer: 5000
              })
              .fire({
                icon: "success",
                title: 'Serials Updated'
              });
            this.extraCostDialogLoading = false;
            this.$emit('submit')
            this.close()
          }
        })
        .catch(err => {
          this.extraCostDialogLoading = false;
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000
            })
            .fire({
              icon: "error",
              title: err.data.message
            });
        });
    },
    close() {
      this.serialNumber = null,
      this.serialList = [],
      this.price = null,
      this.selectedProduct = null,
        this.$emit('close')
    }
  }
}
</script>